import {
    getOrganizationClientTasksLink,
    getOrganizationClientWorkLink,
} from "@components/organizationView/clients-tasks/organizationTaskLink";
import { Menu } from "@design-system/Menu/Menu.lib";
import { useTypedFlags } from "@hooks/useTypedFlags";

/**
 * A client row's `⋯` menu in the org side nav: Open client, and with close
 * management on (the firm pages exist) View in Actions and View in Home.
 */
export const ClientRowMenu = ({
    client,
    onOpenClient,
}: {
    client: { id: string; name: string };
    onOpenClient: () => void;
}) => {
    const { closeManagement: isCloseManagementEnabled } = useTypedFlags();

    return (
        <Menu.More aria-label={`${client.name} actions`} size="xs">
            <Menu.Item onClick={onOpenClient}>Open client</Menu.Item>
            {isCloseManagementEnabled && (
                <>
                    <Menu.LinkItem
                        to={getOrganizationClientTasksLink({
                            workspaceId: client.id,
                        })}
                    >
                        View in Actions
                    </Menu.LinkItem>
                    <Menu.LinkItem
                        to={getOrganizationClientWorkLink(client.id)}
                    >
                        View in Home
                    </Menu.LinkItem>
                </>
            )}
        </Menu.More>
    );
};
